import i18n from 'i18n';
import { useTranslation } from 'react-i18next';
import { useContentLanguage } from 'store';
import { mergeObject } from './function';
import isEmpty from 'lodash/isEmpty';

export const GenerateDataTranslation = (filename: string, commonStatusKey?: string) => {
  useTranslation([filename, 'commonStatus']);
  const [globalContentLanguage] = useContentLanguage();
  let content = i18n.getResourceBundle(globalContentLanguage, filename);
  if (!!commonStatusKey) {
    const commonStatusFile = i18n.getResourceBundle(globalContentLanguage, 'commonStatus');
    if (!!commonStatusFile) {
      return {...content, commonStatus: commonStatusFile[commonStatusKey]}
    }
  }
  return content;
}

export const mappingLocale = (localeConfig: object, locale: object) => {
  return mergeObject(locale, localeConfig);
};

export const replaceVarsInTranslation = <T extends object>(
  translation: T,
  variables: Record<string, string>,
): T => {
  if (isEmpty(translation)) return {} as T;
  const entries = Object.entries(translation).map(([key, value]) => {
    const replacedValue = typeof value === 'string'
    ? value.replace(/\{\{(\w+)\}\}/g, (_match, group) => variables[group])
    : replaceVarsInTranslation(value, variables);
    return [key, replacedValue];
  });
  return Object.fromEntries(entries) as T;
};
